import React from 'react';

const EmptyState = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-white/10 bg-white/[0.02] px-6 py-14 text-center">
    {Icon && <Icon className="mb-4 h-12 w-12 text-slate-500" />}
    <h4 className="text-lg font-semibold text-white">{title}</h4>
    {description && <p className="mt-2 max-w-md text-sm text-slate-400">{description}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);

export default EmptyState;
